import localeText from '@/locales/datagrid'
import { TextField } from '@mui/material'
import { useThemeStore } from 'global/components/ToggleTheme'
import React from 'react'
import ColumnEnum from '../utils/columEnum'
import { GridFilterItemPro, GridFilterModelPro } from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import FilterPanelSelect from './PanelSelect'

export default function FieldValue({
    column,
    onFilterModelChange,
    item,
    className,
}: {
    column: GridColDefPro
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    const theme = useThemeStore(state => state.theme)
    const props = {
        label: localeText.filterPanelValue,
        variant: 'outlined' as const,
        size: 'small' as const,
        defaultValue: item.value,
        className: className,
        autoComplete: 'off',
        onChange: (e: any) => {
            onFilterModelChange(prev => ({
                ...prev,
                items: prev.items.map(p =>
                    p.id === item.id
                        ? {
                              ...p,
                              value: e.target.value,
                          }
                        : p,
                ),
            }))
        },
    }

    return React.useMemo(() => {
        if (!item.operatorValue) return <div className={className} />
        else if (['isEmpty', 'isNotEmpty'].includes(item.operatorValue))
            return <div className={className} />
        else if (['SN', 'boolean'].includes(String(column.type)))
            return (
                <FilterPanelSelect
                    {...props}
                    options={[
                        {
                            label: localeText.filterPanelValueYes,
                            value: column.type === 'SN' ? 'S' : 'true',
                        },
                        {
                            label: localeText.filterPanelValueNo,
                            value: column.type === 'SN' ? 'N' : 'false',
                        },
                    ]}
                />
            )
        else if (ColumnEnum.isColumnEnum(column.type))
            return <FilterPanelSelect {...props} options={column.type.itens} />
        else
            return (
                <TextField
                    {...props}
                    type={column.type}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )
    }, [item.operatorValue, column.type, theme])
}
